const DEFAULT_SITE_URL = "https://www.parmeetasija.com";

/** Strip trailing slashes so robots/sitemap/OG joins never get `//`. */
const normalizeSiteUrl = (url) =>
  String(url || DEFAULT_SITE_URL)
    .trim()
    .replace(/\/+$/, "");

module.exports = {
  title: "Parmeet Singh Asija",
  keywords: ["React developer", "Full stack developer", "Web developer"],
  description:
    "Parmeet Singh Asija is a freelance front-end developer from India specializing in React, Javascript & Typescript",
  author: "Parmeet Singh Asija",
  defaultLang: "en",
  langTextMap: {
    en: "English",
  },
  siteUrl: normalizeSiteUrl(process.env.GATSBY_WEBSITE_URL),
  address: {
    city: "Ludhiana",
    region: "Punjab",
    country: "India",
    zipCode: "141002",
  },

  contact: {
    email: "parmeetsasija@gmail.com",
    phoneNumber: "+91 7009028471",
  },
  image: "https://images.clickforcode.workers.dev/people-webp/PFP.webp",

  socialLinks: {
    whatsapp: "",
  },

  jobTitle: "Senior frontend developer",

  //   TODO: PWA Manifest related
  // Used for App and Offline manifest e.g. Mobile home screen
  /* shortTitle: `Jamify`,
  siteIcon: `favicon.png`,
  backgroundColor: `#e9e9e9`,
  themeColor: `#15171A`,

  short_name: "HI",
  start_url: "/",
  background_color: "#ffffff",
  theme_color: "#0803FC",
 */
};

/* 

module.exports = {
  title: "Harmindera International",
  keywords: [
    "Harmindera International",
    "Auto part manufacturer",
    "Flange manufacturer in Ludhiana",
    "Nuts and Bolts manufacturer",
    "Bolts manufacturer",
    "Forging",
    "Manufacturer in Ludhiana",
    "Agriculture parts manufacturer in Ludhiana",
  ],
  description: "Harmindera International is a ludhiana based manufacturing firm",
  author: "parmeetsingh1402",
  //   trackingId: "UA-119418003-5",
  defaultLang: "en",
  langTextMap: {
    en: "English",
    // ja: "Japanese",
  },
  siteUrl: "https://harminderainternational.gatsbyjs.io",

  address: {
    city: "City",
    region: "Region",
    country: "Country",
    zipCode: "ZipCode",
  },

  contact: {
    email: "email",
    phoneNumber: "phone number",
  },
  foundingDate: "1970",

  googleAnalyticsID: "dfd",
  socialLinks: {
    whatsapp: "",
  },

  // Used for App and Offline manifest e.g. Mobile home screen
  shortTitle: `Jamify`,
  siteIcon: `favicon.png`,
  backgroundColor: `#e9e9e9`,
  themeColor: `#15171A`,

  short_name: "HI",
  start_url: "/",
  background_color: "#ffffff",
  theme_color: "#0803FC",
};

/* 
  title: 'Ghost',
  description: 'The professional publishing platform',
  coverImage: 'img/blog-cover.png',
  logo: 'img/ghost-logo.png',
  lang: 'en',
  siteUrl: 'https://gatsby-casper.netlify.com',
  facebook: 'https://www.facebook.com/ghost',
  twitter: 'https://twitter.com/tryghost',
  showSubscribe: true,
  mailchimpAction: 'https://twitter.us19.list-manage.com/subscribe/post?u=a89b6987ac248c81b0b7f3a0f&amp;id=7d777b7d75',
  mailchimpName: 'b_a89b6987ac248c81b0b7f3a0f_7d777b7d75',
  mailchimpEmailFieldName: 'MERGE0',
  googleSiteVerification: 'GoogleCode',
  footer: 'is based on Gatsby Casper',

*/
